"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _omit = _interopRequireDefault(require("lodash/omit"));

var _styles = require("@material-ui/core/styles");

var _DialogContentText = _interopRequireDefault(require("@eig-builder/core-ui/DialogContentText"));

// Helpers
var StyledDialogContentText = (0, _styles.withStyles)(function (theme) {
  return {
    root: {
      marginBottom: '0'
    }
  };
})(_DialogContentText["default"]);

var Text = function Text(props) {
  return _react["default"].createElement(StyledDialogContentText, (0, _omit["default"])(props, 'children'), props.children);
};

Text.propTypes = {
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node])
};
var _default = Text;
exports["default"] = _default;